var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgWithdrawal = function SvgWithdrawal(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69870",
    "data-name": "Group 69870",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.025,
    height: 21.025,
    viewBox: "0 0 21.025 21.025",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69869",
    "data-name": "Group 69869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69868",
    "data-name": "Group 69868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69867",
    "data-name": "Group 69867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34245",
    "data-name": "Path 34245",
    d: "M172.993,262.931l-1.517,1.5v-7.609a.821.821,0,0,0-1.643,0v7.527l-1.435-1.418a.821.821,0,1,0-1.155,1.168l1.708,1.688a2.458,2.458,0,0,0,3.488,0l1.708-1.688a.821.821,0,0,0-1.155-1.168Z",
    transform: "translate(-160.142 -245.487)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34246",
    "data-name": "Path 34246",
    d: "M323.227,276a.821.821,0,0,0-.821.821,1.644,1.644,0,0,1-1.643,1.643h-3.942a.821.821,0,0,0,0,1.643h3.942a3.289,3.289,0,0,0,3.285-3.285A.821.821,0,0,0,323.227,276Z",
    transform: "translate(-303.023 -264.666)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34247",
    "data-name": "Path 34247",
    d: "M161.413,86.062a.821.821,0,0,0,1.135-.246,4.62,4.62,0,0,0,.747-2.5,4.157,4.157,0,1,0-8.3,0,4.514,4.514,0,0,0,.708,2.506.821.821,0,1,0,1.377-.9,2.9,2.9,0,0,1-.442-1.611,2.52,2.52,0,1,1,5.01,0,2.98,2.98,0,0,1-.485,1.614A.821.821,0,0,0,161.413,86.062Z",
    transform: "translate(-148.635 -75.639)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5821",
    "data-name": "Ellipse 5821",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(16 6.537)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5822",
    "data-name": "Ellipse 5822",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(3 6.537)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34248",
    "data-name": "Path 34248",
    d: "M17.74,0H3.285A3.289,3.289,0,0,0,0,3.285v8.87a3.289,3.289,0,0,0,3.285,3.285H7.227a.821.821,0,1,0,0-1.643H3.285a1.644,1.644,0,0,1-1.643-1.643V3.285A1.644,1.644,0,0,1,3.285,1.643H17.74a1.644,1.644,0,0,1,1.643,1.643V8.049a.821.821,0,1,0,1.643,0V3.285A3.289,3.289,0,0,0,17.74,0Z",
    fill: "#8d8db5"
  }))))));
};

export default SvgWithdrawal;